<template>
  <div class="describe">
    <div class="header">
      <div class="title">智能门禁硬件描述</div>
      <div class="border"></div>
    </div>

    <div class="body">
      <div class="left">
        <img :src="doordescribeLogo" alt="" />
      </div>
      <div class="right">
        <div class="title">多种开门方式 软硬联动</div>
        <div class="text">
          系统支持多种开门方式，活体人脸识别、密码输入、指纹开门等，自动识别陌生人，减少安全隐患。
        </div>
        <div class="item" v-for="item in list" :key="item.id">
          <img :src="item.logo" alt="" />
          <div>{{ item.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import doordescribeLogo from "../../../../assets/programme/doordescribeLogo.png";
import yesLogo from "../../../../assets/programme/yesLogo.png";

export default {
  setup() {
    return reactive({
      doordescribeLogo: doordescribeLogo,
      list: [
        {
          id: 1,
          title: "安全性",
          logo: yesLogo,
        },
        {
          id: 2,
          title: "兼容性",
          logo: yesLogo,
        },
        {
          id: 3,
          title: "方便性",
          logo: yesLogo,
        },
      ],
    });
  },
};
</script>

<style scoped>
.describe {
  width: 1180px;
  margin: 80px auto 0;
}
.header .title {
  font-size: 30px;
  text-align: center;
}
.header .border {
  width: 40px;
  height: 5px;
  background: #248efb;
  margin: 20px auto 0;
}

.body {
    display: flex;
    margin-top: 40px;
}
.body .left img {
   width: 623px;
   margin-right: 60px; 
}

.body .right .title {
    margin-top: 33px;
}
.body .right .text {
    margin-top: 20px;
    font-size: 14px;
    color: #3D3D3D;
}
.body .right .item {
    display: flex;
    align-items: center;
    margin-top: 40px;
}
.body .right .item img {
    width: 18px;
    margin-right: 10px;
}
.body .right .item div {
    font-size: 14px;
    color: #2A3D50;
}
</style>
